/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store/store";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router } from "react-router-dom";
import Socket from "./multiplayer/Socket";
import PrivateRouter from "./PrivateRouter";
import Login from "./Login"
import * as process from 'process';

export default Login;

window.global = window;
window.process = process;
window.Buffer = [];

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <Router>
            <PrivateRouter />
            <Socket />
        </Router>
    </Provider>
)


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();